import React from 'react';
import { Button, Link, Dialog, DialogTrigger, Popover } from 'react-aria-components';
import SvgIcon from '../../utils/SvgIcon';

interface DownloadDocsBtnIndividualProps {
  readonly rowId: string;
  readonly placement?: 'bottom' | 'bottom start' | 'bottom end';
}

export default function DownloadDocsBtnIndividual({
  rowId,
  placement = 'bottom',
}: Readonly<DownloadDocsBtnIndividualProps>) {
  const [buttonIcon, setButtonIcon] = React.useState<string | null>('down');

  return (
    <DialogTrigger onOpenChange={isOpen => setButtonIcon(isOpen ? 'up' : 'down')}>
      <Button className="portal-cell__download-btn cta cta--secondary cta--small" aria-label="Download documents">
        <SvgIcon iconName="download-medium" className="portal-cell__download-btn-icon icon" aria-hidden="true" />
        <SvgIcon
          iconName={`nav-arrow-${buttonIcon}-solid`}
          className="portal-cell__arrow-btn-icon icon"
          aria-hidden="true"
        />
      </Button>
      <Popover className="portal-cell__download-popover" placement={placement} shouldFlip={false}>
        <Dialog className="portal-cell__download-dialog">
          <Link href={`/api/downloads/invoice/${rowId}`} className="portal-cell__download-link">
            Download invoices
          </Link>
          <Link href={`/api/downloads/invoice/with-supporting/${rowId}`} className="portal-cell__download-link">
            Download all documents
          </Link>
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
}
